module.exports = __webpack_public_path__ + "img/title.95515f2e.png";